"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.defineCustomAxiosConfig = defineCustomAxiosConfig;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _axios = _interopRequireDefault(require("axios"));
var _urlParse = _interopRequireDefault(require("url-parse"));
var _vue = _interopRequireDefault(require("vue"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _util = require("@jdcloud/jelement-biz/dist/utils/util");
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var AxiosFactory = /*#__PURE__*/function () {
  function AxiosFactory(opt) {
    (0, _classCallCheck2.default)(this, AxiosFactory);
    var instance = _axios.default.create(_objectSpread(_objectSpread({}, {
      timeout: 30000,
      withCredentials: true
    }), opt));
    instance.interceptors.request.use(this.handleReqSuccess.bind(instance), this.handleReqError.bind(instance));
    instance.interceptors.response.use(this.handleResSuccess.bind(instance), this.handleResError.bind(instance));
    return instance;
  }
  (0, _createClass2.default)(AxiosFactory, [{
    key: "handleReqSuccess",
    value: function handleReqSuccess(config) {
      // default config
      if (this.defaults && this.defaults.pure) return config;

      // computing env tag
      var ENV = getComponentEnv(this.defaults && this.defaults.extra && this.defaults.extra.componentName);
      config.baseURL = handleConfigBaseUrl(ENV, config.baseURL, this.defaults.baseURL);
      config.headers = handleConfigHeader(config.headers);

      // merge custom axios config with internal axios config
      if (_vue.default.prototype.$JELEMENT_BIZ_CUSTOM_AXIOS_CONFIG) {
        config = (0, _deepmerge.default)(config, _vue.default.prototype.$JELEMENT_BIZ_CUSTOM_AXIOS_CONFIG);
      }
      return config;
    }
  }, {
    key: "handleReqError",
    value: function handleReqError(error) {
      if (this.defaults && this.defaults.pure) return _promise.default.reject(error);
      return _promise.default.reject(error);
    }
  }, {
    key: "handleResSuccess",
    value: function handleResSuccess(response) {
      if (this.defaults && this.defaults.pure) return response;
      if (response.data.error && response.data.error.code !== 200 // 一群傻逼，写个API都不按标准写，无力争辩了
      ) {
        return _promise.default.reject(response.data.error);
      }
      return response.data.result ? response.data.result : response.data;
    }
  }, {
    key: "handleResError",
    value: function handleResError(error) {
      if (this.defaults && this.defaults.pure) return _promise.default.reject(error);
      return _promise.default.reject(error);
    }
  }]);
  return AxiosFactory;
}();
/**
 *  根据组件对应 env 是否为 url 或 [locale/ite/stag/prod] 设置对应 baseURL
 *
 * @param {*} env 组件对应 env
 * @param {*} baseURL axios 单个请求实例的 config.baseURL
 * @param {*} defaultBaseURL axios defaults config.baseURL
 * @returns url
 */
function handleConfigBaseUrl(env, baseURL, defaultBaseURL) {
  var baseUrl = checkEnvIsBaseUrl(env);
  if (baseUrl) return baseUrl;
  var url = '';
  if (baseURL) {
    url = baseURL;
  } else if (defaultBaseURL) {
    url = defaultBaseURL;
  } else {
    url = _vue.default.prototype.$JELEMENT_BIZ_TYPE === 'back' ? 'http://jelement-biz-server.jcloud.com' : 'https://jelement-biz-server.jdcloud.com';
  }
  var parsed = (0, _urlParse.default)(url);
  if (['stag', 'test', 'ite'].indexOf(env) > -1) {
    var hostArray = parsed.host.split('.');
    hostArray[0] = hostArray[0] + '-' + env;
    parsed.set('host', hostArray.join('.'));
    parsed.set('protocol', 'http:');
  } else if (env === 'locale') {
    return '';
  }
  url = parsed.href;
  return url;
}
/**
 * 判断 env 是否为标准 url
 *
 * @param {*} env 组件对应 env
 * @returns href or false
 */
function checkEnvIsBaseUrl(env) {
  var url = (0, _urlParse.default)(env, {});
  return url.origin !== 'null' ? url.href : false;
}
function handleConfigHeader() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  headers['Accept-Language'] = _util.ACCEPT_LANGUAGE_MAP[(0, _util.getCurLocale)()];
  headers['Auth-Type'] = _vue.default.prototype.$JELEMENT_BIZ_TYPE || 'console';
  return headers;
}
function defineCustomAxiosConfig(customConfig) {
  _vue.default.prototype.$JELEMENT_BIZ_CUSTOM_AXIOS_CONFIG = customConfig;
}

/**
 * 返回组件对应 env
 *
 * @param {*} componentName axios defaults extra componentName
 * @returns env
 */
function getComponentEnv(componentName) {
  var env = _vue.default.prototype.$JELEMENT_BIZ_ENV;
  if (typeof env === 'string') {
    return env;
  }
  if ((0, _typeof2.default)(env) === 'object' && env !== null && env[componentName]) {
    return env[componentName];
  }
  return 'prod';
}
var _default = AxiosFactory;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/axios.js
// module id = i5AT
// module chunks = 19